import { useAppDispatch } from 'ducks/hooks';
import Box from 'ui/Box';
import Title from 'ui/Typography/Title';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import {
  autofillFrameLayout,
  setAutofillActive,
  setAutoFillFrameLayout
} from 'rangeConfig/pax/features/AutofillPax/AutofillPax';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { ChoiceItem } from '@ingka/choice';
import SkapaChoice from 'ui/Choice/Choice';
import styled from 'styled-components';
import CornerWallIcon from './icons/cornerIcon.svg';
import SingleWallIcon from './icons/singleWallIcon.svg';
import { isMobile } from 'utils/platform';
import { useBehaviorSystem } from 'contexts/behaviors';
import { getSelectedGroupId } from 'ducks/products';

const StyledSkapaChoice = styled(SkapaChoice)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;
`;

const AutoFillOptimizeSpaceFrameLayoutToggle = () => {
  const dispatch = useAppDispatch();
  const selectedIndex = useSelector(autofillFrameLayout);
  const { formatMessage } = useIntl();
  const behaviorSystem = useBehaviorSystem();
  const selectedGroupId = useSelector(getSelectedGroupId);

  if (isMobile()) {
    return <Box mt="s"></Box>;
  }

  const handleClick = (index: number) => {
    behaviorSystem.startReport(`autofill-frame-layout${index}`, {
      groupId: selectedGroupId,
      menuType: 'sheet',
      widgetId: 'autofill-frame-layout',
      meta: { option: index == 0 ? 'single-wall' : 'corner-wall' }
    });
    dispatch(setAutofillActive(true));
    dispatch(setAutoFillFrameLayout(index));
  };

  const ChoiceChildren = [
    <ChoiceItem
      id="autofill-menu-front-layout-option-single-wall"
      data-testid="autofill-menu-front-layout-option-single-wall"
      title={formatMessage({ id: 'storageone.autofillMenuFrontLayoutOptionSingleWall' })}
      image={{ src: SingleWallIcon, alt: 'Single wall icon' }}
      onClick={() => handleClick(0)}
      key="autofill-menu-front-layout-option-single-wall"
    />,
    <ChoiceItem
      id="autofill-menu-front-layout-option-corner-wall"
      data-testid="autofill-menu-front-layout-option-corner-wall"
      title={formatMessage({ id: 'storageone.autofillMenuFrontLayoutOptionCorner' })}
      image={{ src: CornerWallIcon, alt: 'Corner icon' }}
      onClick={() => handleClick(1)}
      key="autofill-menu-front-layout-option-corner-wall"
    />
  ];

  return (
    <Box>
      <Title
        my="md"
        id="autofill-change-frame-layout-heading"
        type={ThemeFontStyleTypeEnum.headingXSmall}
      >
        {formatMessage({ id: 'storageone.autofillPaxWardrobeLayoutOptionsTitle' })}
      </Title>

      <StyledSkapaChoice children={ChoiceChildren} preselectedIndex={selectedIndex} />
    </Box>
  );
};

export default AutoFillOptimizeSpaceFrameLayoutToggle;
